import { render, staticRenderFns } from "./visitRecordDetail.vue?vue&type=template&id=93f3b2ee&scoped=true&"
import script from "./visitRecordDetail.vue?vue&type=script&lang=js&"
export * from "./visitRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./visitRecordDetail.vue?vue&type=style&index=0&id=93f3b2ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f3b2ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93f3b2ee')) {
      api.createRecord('93f3b2ee', component.options)
    } else {
      api.reload('93f3b2ee', component.options)
    }
    module.hot.accept("./visitRecordDetail.vue?vue&type=template&id=93f3b2ee&scoped=true&", function () {
      api.rerender('93f3b2ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/bigCustomer/visit/visitRecordDetail.vue"
export default component.exports